import { Component, input, output, model } from '@angular/core';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-toggle-button',
  imports: [ToggleSwitch, FormsModule],
  templateUrl: './toggle-button.html',
  styleUrl: './toggle-button.scss',
})
export class ToggleButton {
  title = input<string>();
  additionalText = input<string>();
  isDisabled = input<boolean>(false);
  isChecked = model<boolean>(false);
  styleClass = input<string>();
  valueChanged = output<boolean>();

  handleChange() {
    this.valueChanged.emit(this.isChecked());
  }
}
